export default __webpack_public_path__ + "static/media/countries.8121080f.PNG";